import React from 'react';
import LazyImage from '../lib/LazyImage'
import Carousel from '../lib/Carousel'
import uuid from 'uuid'

export default class ImageGallery extends React.Component {
	state = {
		galleryMode: 'mode-gallery',
		current: 0,
		id: 'gallery-'+uuid.v4()
	}

	componentDidMount() {
		const {id} = this.state
		this.html = document.querySelector('html')
		this.container = document.querySelector(`#${id}`)
		this.gallery = document.querySelector(`#${id} .gallery`)
		this.b = 0
		this.si = setInterval(() => {
			this.updateScroll()
		}, 1500)
	}
	updateScroll = () => {
		if(!this.container || !this.gallery) return
		const scroll = parseInt(this.html.style.getPropertyValue('--scroll'), 10)
		const b = this.container.getBoundingClientRect().top + scroll
		const s = this.gallery.getBoundingClientRect().top + scroll
		if (this.b===b) return
		this.container.style.setProperty('--scroll-gallery-block', b)
		this.gallery.style.setProperty('--scroll-gallery', s)
		this.b = b
	}
	componentWillUnmount() {
		this.container = null
		this.gallery = null
		if(this.si) clearInterval(this.si)
		this.si = null
	}

		/*
		let block = document.querySelector(`.node-fields .gallery`)
		let gallery = document.querySelector(`.node-fields .gallery`)
		if(!block || !gallery) return
		block.style.setProperty('--scroll-gallery-block', block.getBoundingClientRect().top)
		gallery.style.setProperty('--scroll-gallery', gallery.getBoundingClientRect().top)
		*/
	
	
	openCarousel = (e) => {
		const index = parseInt(e.currentTarget.getAttribute('data-index'), 10)
		if (this.container) this.container.style.zIndex = 100
		this.setState({galleryMode: 'mode-carousel', current: index})
	}
	
	closeCarousel = (e) => {
		if (this.container) this.container.style.zIndex = 0
		this.setState({galleryMode: 'mode-gallery', current:-1})
	}
	
	render() {
		const {gallery, screen} = this.props
		const {id, galleryMode, current} = this.state

		if(!gallery || gallery.length===0) return null
		return (
			<div id={id} className='gallery-container'>
			<div className={`gallery ${galleryMode}`}>
				<div className='gallery-wrap'>
				<div className='gallery-gallery'>
					{gallery.map((img,i) => <div key={i} className='image' data-index={i}
						onClick={this.openCarousel}>
						<LazyImage key={i} src={img} imageStyle='gallery-th' alt='' screen={screen}/></div>)}
				</div>
				</div>
				<div className='gallery-carousel' key='carousel'>
					<div onClick={this.closeCarousel} className='back-to-gallery'><i className='fa fa-times'></i></div>
					<Carousel className='gallery-carousel' key='carousel' imageStyle='gallery-full'
						items={gallery} current={current} heightFixed={true}/>
				</div>
			</div></div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/fm/block/ImageGallery.js